import { createSelector } from 'reselect'
import { AppState } from 'store/store'

//#region Templates

/**
 *
 * @param state - the application state
 * @returns data - the current templates reducer
 */
export const selectCurrentTemplatesReducer = (state: AppState) => state.templates

/**
 * Gets the templates' array from the templates reducer
 */
export const selectCurrentTemplates = createSelector(
  selectCurrentTemplatesReducer,
  (templates) => templates.data
)
/**
 * Gets the templates' meta from the templates reducer
 */
export const selectCurrentTemplatesMeta = createSelector(
  selectCurrentTemplatesReducer,
  (templates) => templates.meta
)
/**
 * Gets the templates' isFetching from the templates reducer
 */
export const selectCurrentTemplatesIsFetching = createSelector(
  selectCurrentTemplatesReducer,
  (templates) => templates.isFetching
)
//#endregion
